import { z } from 'zod'

export const CreateTrainingEnrollmentSchema = z.object({
  trainingId: z.string().uuid('無効な研修IDです。'),
})

export const BulkAssignSchema = z.object({
  trainingId: z.string().uuid('無効な研修IDです。'),
  userIds: z.array(z.string().uuid()).min(1, { message: '受講者を1名以上選択してください。' }),
})

export const RecordAttendanceSchema = z.object({
  scheduleId: z.string().uuid('無効な日程IDです。'),
  attended: z.boolean(),
})

export const ApproveRejectSchema = z.object({
  comment: z.string().optional(),
})

export const ProxyApproveSchema = z.object({
  comment: z.string().optional(),
})

export type CreateTrainingEnrollmentInput = z.infer<typeof CreateTrainingEnrollmentSchema>
export type BulkAssignInput = z.infer<typeof BulkAssignSchema>
export type RecordAttendanceInput = z.infer<typeof RecordAttendanceSchema>
export type ApproveRejectInput = z.infer<typeof ApproveRejectSchema>
export type ProxyApproveInput = z.infer<typeof ProxyApproveSchema>
